import PermissionShape from '../../shapes/permission';
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import AgGridReact from '../common/ag-table';
import { classes } from './styles/table';
import CheckboxCellComponent from './checkbox-cell';
import { Button } from 'reactstrap';
import { withPermissions } from '../../services/permissions';

class PermissionsView extends React.Component {

  state = {

  };

  constructor(props) {
    super(props);

    this.state.options = {
      context: {
        componentParent: this
      },
      localeText: {
        noRowsToShow: props.t('permissions.emptyMessage')
      },
      frameworkComponents: {
        CheckboxCellComponent
      },
      columnDefs: [
        {
          field: 'key',
          headerName: props.t('permissions.keyHeader')
        },
        {
          field: 'defaultValue',
          headerName: props.t('permissions.defaultValueHeader'),
          cellRenderer: 'CheckboxCellComponent'
        }
      ],
      rowData: [],
      enableFilter: true,
      enableSorting: true
    }
  }

  onDeleteClicked = (event, { data }) => {
    const remove = () => {
      this.gridApi.updateRowData({
        remove: [
          data
        ]
      })
    };

    if (!data.uuid) {
      return remove();
    }

    this.props.onDelete(data, remove);
  };

  onSaveClicked = (event, { data, node }) => {
    const setData = (newData) => {
      node.setData({
        ...newData,
        actions: data.actions
          .filter(action => action !== 'Save')
      });
    };
    this.props.onSave(data, setData);
  };

  onAddEmptyRow = () => {

  };

  render() {
    const { t, hasPermission } = this.props;
    return (
      <React.Fragment>
        <div className={classes.header}>
          <div />
          <h3>{this.props.name || t('permissions.header')}</h3>
          <div>
            <Button onClick={this.onAddEmptyRow}>Add</Button>
          </div>
        </div>
        <div
          className={`ag-theme-blue ${classes.table}`}
        >
          <AgGridReact
            name="application-permissions"
            {...this.state.options}
            items={this.props.permissions}
            identifier="key"
            readOnly={!hasPermission("Manage Permissions")}
          />
        </div>
      </React.Fragment>
    )
  }

}

PermissionsView.propTypes = {
  permissions: PropTypes.arrayOf(PermissionShape).isRequired
};

export default withPermissions(translate(['product'])(PermissionsView));



// WEBPACK FOOTER //
// ./src/views/applications/permissions.js